import { Link as MuiLink } from '@mui/material';

interface ExternalLinkProps {
  href: string;
  children: React.ReactNode;
}

export const ExternalLink = ({ href, children }: ExternalLinkProps) => (
  <MuiLink
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    sx={{
      color: 'primary.main',
      textDecoration: 'none',
      '&:hover': { textDecoration: 'underline' },
    }}
  >
    {children}
  </MuiLink>
);
